import { render, staticRenderFns } from "./TheWelcomeDescription.vue?vue&type=template&id=4c1805ff&scoped=true&"
import script from "./TheWelcomeDescription.vue?vue&type=script&lang=ts&"
export * from "./TheWelcomeDescription.vue?vue&type=script&lang=ts&"
import style0 from "./TheWelcomeDescription.vue?vue&type=style&index=0&id=4c1805ff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1805ff",
  null
  
)

export default component.exports